<template>
    <div>
        <vc-left-menu></vc-left-menu>

        <div :class="{ 'layout-content': true, 'is-active': !getMenuToggle }">
            <div class="page-header-container">
                <div class="page-header clearfix">
                    <h3 class="page-title">
                        {{ $t('words.duplicate_block') }}
                        <span class="page-header-breadcrumb">></span>
                        {{ $t('words.duplicate_block_sessions') }}
                        <small class="text--caption">({{ currentDuplicateBlockPolicyDesc }})</small>
                    </h3>
                </div>
                <ul class="nav nav-tab nav--tab" id="childTab" role="tablist">
                    <li class="nav-item">
                        <router-link class="nav-link active" id="duplicate_block_sessions-nav" :to="{ name: 'cms-preferences-duplicate_block_sessions' }" aria-controls="duplicate_block_sessions" aria-selected="false">{{ $t('words.duplicate_block_sessions') }}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" id="duplicate_block_logs-nav" :to="{ name: 'cms-preferences-duplicate_block_logs' }" aria-controls="duplicate_block_logs" aria-selected="false">{{ $t('words.duplicate_block_logs')}}</router-link>
                    </li>
                    <li class="nav-item">
                        <router-link  class="nav-link" id="duplicate_block_manage-nav" :to="{ name: 'cms-preferences-duplicate_block_manage' }" aria-controls="duplicate_block_manage" aria-selected="false">{{ $t('words.duplicate_block_manage') }}</router-link>
                    </li>
                </ul>
            </div>

            <section class="content">
                <div class="tile">
                    <div class="tile__header">
                        <div class="form--inline">
                            <div class="control-group">
                                <select id="select_kind" :data-placeholder="$t('words.kinds')" v-model="selectedKind">
                                    <option :value="kind" v-for="kind in kinds" :key="kind">
                                        {{ kind === 'live_media_broadcast_key' ? $t(`words.broadcast`) : $t(`words.${kind}`)}}
                                    </option>
                                </select>
                            </div>
                            <form class="control-group" @submit.prevent="doSearch">
                                <input type="text" id="keyword" class="form-control form__search" v-model="keyword" :placeholder="$t('paragraphs.placeholder_search')">
                            </form>
                        </div>
                    </div>
                    <div class="tile__body" v-if="!haveSession" style="padding: 24px">
                        {{ $t('paragraphs.duplicate_block_policy_unavailable') }}
                    </div>
                    <div class="tile__body" v-else>
                        <div class="tile__option-group">
                            <button class="btn btn-icon" @click="doSearch"><i class="icon icon-refresh"></i></button>
                            <ul class="pagination">
                                <li :class="{'page-item': true, disabled: !(sessions.meta.current_page > 1) }">
                                    <button class="page-link" aria-label="Previous" @click="changeCurrentPage(sessions.meta.current_page -1)" v-if="sessions.meta.current_page > 1">
                                        <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                    </button>
                                    <button class="page-link" aria-label="Previous" v-else>
                                        <i class="icon icon-arrow-left-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.previous') }}</span>
                                    </button>
                                </li>
                                <li :class="{'page-item': true, disabled: !(sessions.meta.current_page < sessions.meta.last_page) }">
                                    <button class="page-link" aria-label="Next" @click="changeCurrentPage(sessions.meta.current_page + 1)" v-if="(sessions.meta.current_page < sessions.meta.last_page)">
                                        <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                                    </button>
                                    <button class="page-link disabled" aria-label="Previous" disabled v-else>
                                        <i class="icon icon-arrow-right-sm" aria-hidden="true"></i>
                                        <span class="sr-only">{{ $t('pagination.next') }}</span>
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <table class="table table-wide">
                            <thead>
                            <tr>
                                <th>{{ $t('words.broadcast')}}</th>
                                <th>{{ $t('words.client_user_id')}}</th>
                                <th>{{ $t('words.player_id')}}</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-if="sessions.is_loaded && (sessions.partial_data.length > 0)">
                            <tr v-for="(session, index) in sessions.partial_data" :key="session.id">
                                <td>{{ session.live_media_broadcast_key }}</td>
                                <td>{{ session.client_user_id }}</td>
                                <td>{{ session.player_id }}</td>
                                <td class="cell--action">
                                    <button class="btn--icon btn--icon--sm"  @click="doDestroySession(index + (sessions.meta.current_page-1) * sessions.meta.per_page, session)" >
                                        <i class="icon icon-trash"></i>
                                    </button>
                                </td>
                            </tr>
                            </tbody>
                            <tbody v-else-if="sessions.is_loaded">
                            <tr>
                                <td colspan="4" class="td__message">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 24 24" class="svg-icon svg-icon-alert-circle"><g stroke-linecap="square" stroke-linejoin="miter" stroke-width="2" fill="#adb5bd" stroke="#adb5bd"><circle fill="none" stroke="#adb5bd" stroke-miterlimit="10" cx="12" cy="12" r="11"/> <line data-color="color-2" fill="none" stroke-miterlimit="10" x1="12" y1="7" x2="12" y2="13"/> <circle data-color="color-2" data-stroke="none" cx="12" cy="17" r="1" stroke-linejoin="miter" stroke-linecap="square" stroke="none"/></g></svg>{{ $t('paragraphs.list_empty') }}</td>
                            </tr>
                            </tbody>
                            <tbody v-else>
                            <tr>
                                <td colspan="4" class="td__message"><div class="loader"></div>{{ $t('paragraphs.list_loading') }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </section>
        </div>
    </div>
</template>
<script>
import GlobalConfigMixin from '../mixin/GlobalConfigMixin';

const DUPLICATE_BLOCK_POLICIES = {
    NOT_ALLOWED: 'not used',
    ALLOW_ONE_DEVICE_AT_SAME_TIME: 'allow_one_device_at_same_time',
    ALLOW_REGISTERED_DEVICE: 'allow_registered_device',
    ALLOW_REGISTERED_ONE_DEVICE_AT_SAME_TIME: 'allow_registered_one_device_at_same_time',
};
export default {
    mixins: [
        GlobalConfigMixin,
    ],
    data() {
        return {
            kinds: ['live_media_broadcast_key', 'client_user_id', 'player_id'],
            selectedKind: 'client_user_id',
            keyword: '',
            sessions: {
                links: {
                    prev: null,
                    next: null,
                },
                data: [],
                partial_data: [],
                meta: {
                    last_page: 0,
                    current_page: 1,
                    total: 0,
                    per_page: 100,
                },
                is_loaded: false,
            },
        };
    },
    beforeMount() {
    },
    mounted() {
        const self = this;
        $('#select_kind').selectize({
            maxItems: 1,
            create: true,
            // sortField: 'text',
            onChange(value) {
                self.selectedKind = value;
            },
        });
        if (this.loadedServiceAccount) {
            this.initialize();
        }
    },
    methods: {
        initialize() {
            this.loadSessions();
        },
        doSearch() {
            this.loadSessions();
        },
        loadSessions() {
            axios.get(`${this.sessionApi}?field=${this.selectedKind}&q=${encodeURI(this.keyword)}`).then((response) => {
                this.sessions.data = response.data.response.result;
                this.sessions.meta.total = this.sessions.data ? this.sessions.data.length : 0;
                let lastPage = parseInt(`${this.sessions.meta.total / this.sessions.meta.per_page}`, 10);
                lastPage = this.sessions.meta.total % this.sessions.meta.per_page > 0 ?
                    lastPage + 1 : lastPage;
                this.sessions.meta.last_page = lastPage;
                this.changeCurrentPage();
                this.sessions.is_loaded = true;
            }).catch((error) => {
                this.sessions.is_loaded = true;
            });
        },
        changeCurrentPage(pg = 1) {
            if (this.sessions.meta.last_page < pg) {
                this.sessions.meta.current_page = this.sessions.meta.last_page;
            } else {
                this.sessions.meta.current_page = pg;
            }
            const cloneData = _.cloneDeep(this.sessions.data);
            const startIndex = (this.sessions.meta.current_page - 1) * this.sessions.meta.per_page;
            const lastIndex = startIndex + this.sessions.meta.per_page;
            this.sessions.partial_data = _.slice(cloneData, startIndex, lastIndex);
        },
        removeSession(index) {
            _.pullAt(this.sessions.data, index);
            this.changeCurrentPage(this.sessions.meta.current_page);
        },
        doDestroySession(index, session) {
            if (!this.haveSubmitRight) {
                return;
            }
            if (confirm(this.$t('paragraphs.message.confirm.remove_item'))) {
                axios.delete(`/cms/${this.selectedServiceAccount.key}/duplicate_block/sessions`, {
                    data: {
                        client_user_id: session.client_user_id,
                    },
                }).then(() => {
                    this.$toasted.success(this.$t('paragraphs.message.success.remove'));
                    this.removeSession(index);
                }).catch((error) => {
                    this.$toasted.error(this.$t('paragraphs.message.error.remove'));
                    console.log(error.response.data.errors);
                });
            }
        },
    },
    computed: {
        sessionApi() {
            return `/cms/${this.selectedServiceAccount.key}/duplicate_block/sessions`;
        },
        currentDuplicateBlockPolicy() {
            if (this.selectedServiceAccount && this.selectedServiceAccountContract) {
                return this.selectedServiceAccountContract.duplicate_block_policy;
            }
            return '';
        },
        currentDuplicateBlockPolicyDesc() {
            if (_.isEmpty(this.currentDuplicateBlockPolicy)) {
                return '';
            }
            const policy = this.currentDuplicateBlockPolicy;
            if (policy === 'not used') {
                return '';
            }
            return this.$t(`words.duplicate_block_policy_${policy}`);
        },
        haveSubmitRight() {
            return (!this.modifyMode && this.haveOwnerRight) || (this.modifyMode && this.haveManagerRight);
        },
        haveSession() {
            return this.currentDuplicateBlockPolicy !== DUPLICATE_BLOCK_POLICIES.NOT_ALLOWED && this.currentDuplicateBlockPolicy !== DUPLICATE_BLOCK_POLICIES.ALLOW_REGISTERED_DEVICE;
        },
    },
    watch: {
        loadedServiceAccount(newValue) {
            this.initialize();
        },
    },
};
</script>

<style scoped>
    .table .thead {
        width: 25%;
    }
</style>
